import React from 'react'
import { Text } from 'rebass'
//  import { SiMapbox as SiteLogo } from 'react-icons/si'
import {FcLandscape as SiteLogo} from 'react-icons/all';


import { Link } from 'components/Link'

import { Box, Flex } from 'components/Grid'
import styled, { themeGet } from 'style'
import { siteMetadata } from '../../../gatsby-config'

const Wrapper = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'space-between',
})`
  padding: 0.5rem 0.5rem;
  flex: 0 0 auto;
  border-bottom: 3px solid ${themeGet('colors.red.900')};
`



const Title = styled(Text).attrs({
  as: 'h1',
})`
  margin: 0;
  flex-grow: 0.25;
  line-height: 1;
  font: "Raleway",sans-serif;
  font-family: 'Neue Helvetica','Roboto', sans-serif;


  & * {
    text-decoration: none;
  }
`

// font-family: -apple-system,BlinkMacSystemFont,"Neue Helvetica","Roboto","Segoe UI","Arial","Noto Sans",serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
//   "Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";


const NavBar = styled(Flex).attrs({
  alignItems: 'left',
})`
  font-size: 1.75rem;
  font: "Raleway",sans-serif;

  font-family: -apple-system,BlinkMacSystemFont,"Neue Helvetica","Roboto","Segoe UI","Arial","Noto Sans",serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";

  .nav-active {
    color: ${themeGet('colors.highlight.500')};
  }
`

const NavLink = styled(Link)`
  text-decoration: none;
  padding: 0 0.8rem;
  font-size: large;
  font: "Raleway",sans-serif;

  font-family: -apple-system,BlinkMacSystemFont,"Neue Helvetica","Roboto","Segoe UI","Arial","Noto Sans",serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  &:hover {
    text-decoration: underline;
  }
`

const Header = () => (
  <Wrapper as="header">
    <Title>
      <Link to="https://milano-cortina-2026.netlify.app/">
        <Flex alignItems="center" flexWrap="wrap">
          <Box mr="1rem">
            <SiteLogo />
          </Box>
          {siteMetadata.title}
        </Flex>
      </Link>
    </Title>
    <NavBar>
      {/*
      <NavLink to="/map-full" activeClassName="nav-active">
        See the Place
      </NavLink>
      */}
      <NavLink to="/" activeClassName="nav-active">
        Read the Story
      </NavLink>
      <NavLink to="/map-direction" activeClassName="nav-active">
        How to Reach Cortina
      </NavLink>
      <NavLink to="https://milano-cortina-2026.netlify.app/" activeClassName="nav-active">
        Home Page
      </NavLink>

    </NavBar>
  </Wrapper>
)

export default Header

/*
<NavLink to="/map" activeClassName="nav-active">
        Data Collected
      </NavLink>
      <NavLink to="/map-geojson-simple" activeClassName="nav-active">
        Project Territory
      </NavLink>
      <NavLink to="/map-swipe" activeClassName="nav-active">
        Solutions
      </NavLink>
* */